export default __webpack_public_path__ + "static/assets/96205cad1e7fd0c7e9d57faf99300539.png";